module.exports = "https://coursera_assets.s3.amazonaws.com/images/3107b9ad877efaedc0b4c5386f257866.png";